import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pets: FaireCategoryEntity = {
  token: "cat_pets",
  type: "category",
  name: "Pets",
  level: 1,
  href: "/category/pets",
  childCategoryTokens: [
    "cat_pets-all",
    "cat_pets-new-products",
    "cat_pets-new-brands",
    "cat_pets-bestsellers",
    "cat_pets-dog",
    "cat_pets-cat",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
